import { Link } from 'react-router-dom';
import { useState } from 'react';
import { siteInfo } from '@/mocks/home';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    try {
      const response = await fetch('http://heiliaochigua.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[40%]">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50">51动漫</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6">
              {siteInfo.description.slice(0, 120)}...
            </p>
            <div className="mb-6">
              <p className="text-foreground-300 text-xs mb-2">订阅更新通知</p>
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅更新"
                  required
                  className="flex-1 bg-background-800 text-background-100 text-sm px-4 py-2.5 rounded-lg border-0 outline-none focus:ring-2 focus:ring-primary-500 placeholder:text-foreground-500"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </form>
              {status === 'success' && (
                <p className="text-accent-400 text-xs mt-2">订阅成功！感谢关注51动漫。</p>
              )}
              {status === 'error' && (
                <p className="text-primary-400 text-xs mt-2">{errorMsg}</p>
              )}
            </div>
          </div>

          <div className="flex-1 grid grid-cols-3 gap-6">
            <div>
              <h4 className="text-background-50 text-sm font-medium mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                {siteInfo.footerLinks.quickNav.map((link) => (
                  <Link
                    key={link.name}
                    to={link.link}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-background-50 text-sm font-medium mb-4">帮助中心</h4>
              <div className="flex flex-col gap-2.5">
                {siteInfo.footerLinks.help.map((link) => (
                  <Link
                    key={link.name}
                    to={link.link}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-background-50 text-sm font-medium mb-4">法律信息</h4>
              <div className="flex flex-col gap-2.5">
                {siteInfo.footerLinks.legal.map((link) => (
                  <Link
                    key={link.name}
                    to={link.link}
                    className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 51动漫 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-background-100 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-100 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-100 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}